import { useCallback } from "react";

import { useProductDayTripPlanI18nFormModelContext } from "../../../../_context";

export const usePlanName = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanI18nFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
